import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Footer from './components/footer';
import Header from './components/header';
import LandingPage from './scenes/landingPage';
import PrivacyPolicy from './scenes/privacyPolicy';
import TermsOfService from './scenes/termsOfService';
import ScrollToTop from './containers/scrollToTop';
import FileNotFound from './scenes/statusPages/fileNotFound';
import './App.css';

// Switch will return the first path that matches, allowing us to have a catch all path at the end
// which can be useful for the 404
class App extends Component {
  render() {
    return (
      <Router>
        <ScrollToTop>
          <div className="App">
            <Header />
            <div className="Content">
              <Switch>
                <Route exact path="/" component={LandingPage} />
                <Route exact path="/privacy" component={PrivacyPolicy} />
                <Route
                  exact
                  path="/support"
                  component={() =>
                    (window.location = 'https://actfit.freshdesk.com')
                  }
                />
                <Route exact path="/terms" component={TermsOfService} />
                <Route
                  exact
                  path="/get"
                  component={() =>
                    (window.location = 'http://onelink.to/mthk7h')
                  }
                />
                <Route component={FileNotFound} />
              </Switch>
            </div>
            <Footer />
          </div>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js